import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\b\\baczonedz\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PublicHeader"] */ "D:\\b\\baczonedz\\src\\components\\public-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "D:\\b\\baczonedz\\src\\components\\ui\\site-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactBody"] */ "D:\\b\\baczonedz\\src\\features\\legal\\contact-body.tsx");
